import useViewport from "../../../Utilities/useViewport";
import APLTabs from "./APLTabs";
import MobileAPLTabs from "./MobileAPLTabs";
import { SetNavigationProps } from "../../../actions/teacherTabNavActions";
import { useDispatch } from "react-redux";

export default function APLTabNavSelector({
  activeTab,
  toggleCreatePeriod,
  periodsToSelect,
  period,
}) {
  const { width } = useViewport();
  const breakpoint = 620;

  const dispatch = useDispatch();

  const handleSelectPeriod = (event) => {
    dispatch(SetNavigationProps("selectedAplPeriod", event.value));
  };

  let selectedPeriod = null;
  if (period !== null) {
    selectedPeriod = periodsToSelect.find(
      (pts) => pts.value === period.period.id
    );
  }
  const handleSetAplTab = (tabNr) => {
    dispatch(SetNavigationProps("selectedAplTab", tabNr));
  };

  return width < breakpoint ? (
    <MobileAPLTabs
      toggleCreatePeriod={toggleCreatePeriod}
      periodsToSelect={periodsToSelect}
      period={period}
      activeTab={activeTab}
      handleSelectPeriod={handleSelectPeriod}
      selectedPeriod={selectedPeriod}
      handleSetAplTab={handleSetAplTab}
    />
  ) : (
    <APLTabs
      toggleCreatePeriod={toggleCreatePeriod}
      periodsToSelect={periodsToSelect}
      period={period}
      activeTab={activeTab}
      handleSelectPeriod={handleSelectPeriod}
      selectedPeriod={selectedPeriod}
      handleSetAplTab={handleSetAplTab}
    />
  );
}
